import { render, staticRenderFns } from "./RoleGroups.vue?vue&type=template&id=4f4d350c&scoped=true&"
import script from "./RoleGroups.vue?vue&type=script&lang=js&"
export * from "./RoleGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4d350c",
  null
  
)

export default component.exports